import type { NotifyPort } from '@/features/messages/domain/notify'
import type { TimeOffPort, TimeOffRequestFilter, TimeOffRequest } from '../domain/timeoff'

const listTimeOffRequests = async (
	port: TimeOffPort,
	filter: TimeOffRequestFilter,
	notify: NotifyPort,
): Promise<TimeOffRequest[]> => {
	try {
		return await port.listRequests(filter)
	} catch (err) {
		if ((err as { isAbort?: boolean })?.isAbort) return []

		notify.error('hr.timeOffRequestsLoadFailed')
		return []
	}
}

export { listTimeOffRequests }
